/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import BoardItem from './BoardItem/index'
import React from 'react'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let boardsBoardsValueData = fromData.useDataValue({ viewPath,
context: 'boards',
path: 'boards',
})
let taskBoardsListIconOnlyValueData = fromData.useDataValue({ viewPath,
context: 'task_boards_list',
path: 'iconOnly',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(boardsBoardsValueData) && boardsBoardsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="board"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/BoardItem(${item?.id ?? item?._id ?? index})`}
      >
<BoardItem
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/BoardItem(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
<fromFlow.When is={taskBoardsListIconOnlyValueData}>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 width={36}
 marginRight="auto"
 marginLeft="auto"
 marginTop={0}
 theme="light"
 data="task_boards_list.iconOnly"
/>
</fromFlow.When>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }